import styled from 'styled-components';

export const PageContainer = styled.div`
  height: 100%;
  width: 100%;
  background-color: #ffffff;
`;

export const DivisionCards = styled.div`
  @media (min-width: 930px) {
    padding-right: 150px;
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
  }

  @media (max-width: 929px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

export const DivisionChangeName = styled.div`
  width: 100%;
  margin: 0rem 3rem 0 0;

  @media (max-width: 768px) {
    width: 100%;
    height: 100vh;
    margin: 0rem;
    background-color: white;
  }

  h3 {
    font-size: 1.1rem;
    color: #808080;
  }

  label {
    font-size: 1rem;
    color: #808080;
    margin-bottom: 0.2rem;
  }

  input {
    box-shadow: 0px 2px 4px #00000066;
    border-radius: 0.4rem;
    border: 0;
    padding: 0.91rem;
  }
`;

export const DivisionButton = styled.div`
  margin: 2rem 0 0 0rem;
  width: 20%;

  @media (max-width: 1700px) {
    width: 30%;
  }

  @media (max-width: 1400px) {
    width: 40%;
  }

  @media (max-width: 920px) {
    width: 50%;
  }

  @media (max-width: 770px) {
    margin: 2rem 0 0 0rem;
    width: 100%;
  }
`;

export const InsertName = styled.div`
  display: flex;
  flex-direction: column;
  margin: 3rem 0 0 0rem;
  width: 20%;

  @media (max-width: 1700px) {
    width: 30%;
  }

  @media (max-width: 1400px) {
    width: 40%;
  }

  @media (max-width: 920px) {
    width: 50%;
  }

  @media (max-width: 770px) {
    margin: 0rem 0 0 0rem;
    width: 100%;
  }

  input {
    border: 1px solid #b0b0b0;

    @media (max-width: 770px) {
      font-size: 0.85rem;
    }
  }
`;

export const BackIcon = styled.span`
  display: flex;
  justify-content: flex-end;
  margin: 0rem 5rem 1.5rem 0;
  cursor: pointer;

  @media (max-width: 1366px) {
    margin: 0 5rem 0 0;
  }

  @media (max-width: 770px) {
    margin: 1rem 1rem 1rem 0;
  }
`;

export const Content = styled.div`
  height: 75vh;
  padding: 0.5rem 2rem 2rem 2rem;
  margin: 0 0 0 3rem;
  overflow-y: scroll;

  @media (max-width: 400px) {
    padding: 0.5rem 1rem 2rem 1rem;
  }

  @media (max-width: 400px) {
    padding: 0.5rem 1rem 2rem 1rem;
  }

  @media (max-width: 770px) {
    margin: 0;
  }
`;

export const IconLoading = styled.i`
  font-size: 1.5rem;
`;

export const HeaderContainer = styled.div`
  width: 100%;
  padding: 0 0 20px 20px;
  background-color: white;

  @media (max-width: 770px) {
    padding: 0;
    display: none;
  }
`;

export const HeaderMobileContainer = styled.div`
  width: 100%;
  background-color: white;

  @media (min-width: 770px) {
    padding: 0;
    display: none;
  }
`;

export const Left = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  margin: 1rem 0 0rem 0rem;

  @media (max-width: 1000px) {
    width: 100%;
  }
  @media (max-width: 768px) {
    margin-left: 0px;
    margin: 3rem 0 2rem 0rem;
  }
`;

export const ValeIcon = styled.img`
  width: 39px;
  height: 26px;
  margin-right: 20px;
`;

export const PageTitle = styled.span`
  color: #808080;
  font-size: 20px;
  font-weight: 300;
`;

export const ModalErrorMessage = styled.div`
  padding: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #707070;
`;

export const ContainerTitle = styled.section`
  display: flex;
`;

export const ContentImage = styled.div`
  width: 5rem;
  height: 5rem;

  img {
    width: 100%;
    height: 100%;
  }
`;

export const TitleInfo = styled.section`
  margin: 0 0 0 1rem;
  color: #707070;

  div {
    display: flex;
    flex-wrap: wrap;
    margin: 0.5rem 0 0.5rem 0;
  }

  h4 {
    font-size: 1.1rem;
    margin-right: 0.3rem;
  }

  a {
    color: #000fff;
    font-size: 0.91rem;

    @media (max-width: 350px) {
      font-size: 0.75rem;
    }
  }

  span {
    font-size: 0.91rem;

    @media (max-width: 350px) {
      font-size: 0.75rem;
    }
  }
`;

export const ContainerAvaliation = styled.section`
  margin: 2rem 0 0 0;

  a {
    color: #000fff !important;
    font-weight: 600 !important;
    text-decoration: underline !important;
    cursor: pointer !important;
  }

  h4 {
    font-size: 1.2rem;
    font-weight: 600;
    color: #707070;
  }

  @media (max-width: 929px) {
    padding-bottom: 50px;
  }
`;

export const StarDivision = styled.div`
  padding: 0rem 0 1rem 0;

  @media (min-width: 900px) {
    width: 30%;
  }

  @media (min-width: 770px) and (max-width: 900px) {
    width: 60%;
  }

  .MuiRating-root {
    font-size: 2.5rem;
    width: 100%;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    margin: 1rem 0rem 1rem -0.3rem;

    span {
      display: flex !important;
      justify-content: center !important;
    }

    .MuiRating-icon {
      display: flex !important;
      justify-content: center !important;
    }

    span.MuiRating-icon {
      display: flex !important;
      justify-content: center !important;
    }

    @media (max-width: 770px) {
      margin: 1rem 0rem;
    }
  }

  p {
    color: #5a5a5a;
    margin: 0 0 1rem 0;
    word-wrap: break-word;
  }

  h4 {
    color: #5a5a5a;
    font-weight: 550;
    font-size: 1rem;
    display: flex;
    justify-content: space-between;

    span {
      color: #9e9e9e;
      font-weight: 400;
      font-size: 0.8rem;
    }
  }
`;

export const ContainerVisit = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffff;
`;

export const ContentVisit = styled.div`
  height: 95%;
  width: 100%;

  @media (max-width: 768px) {
    height: 100vh;
    width: 100%;
  }
`;

export const WrapperVisitTable = styled.div`
  height: 89%;
  width: 100%;

  @media (max-width: 770px) {
    margin-top: 0px;
  }
`;

export const PageTitleContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 40px;
  margin-bottom: 30px;
`;

export const PageTitleItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const PageTitleVisit = styled.span`
  color: #808080;
  font-size: 20px;
  font-weight: 300;
`;

export const VisitMessage = styled.div`
  display: flex;
  justify-content: center;
  margin: 1rem 0 0 0;

  span {
    color: #808080;
  }
`;

export const VisitContainer = styled.div`
  width: 100%;
`;

export const DesktopWrapper = styled.div`
  width: 100vw;
  display: none;

  @media (min-width: 1000px) {
    display: initial;
  }
`;

export const MobileWrapper = styled.div`
  width: 100vw;
  display: none;

  @media (max-width: 1000px) {
    display: initial;
  }
`;

export const NextPageContainer = styled.div`
  display: flex;
  justify-content: ${(props) => props.content};
  margin-bottom: 1.5rem;
  color: #000FFF;
`;

export const NextPage = styled.span`
  color: #000FFF;
  padding: 0.5rem;
  border-radius: 0.5rem;
  cursor: pointer;
`;

export const ContentModal = styled.span`
  padding: 30px;
`;

export const CloseIcon = styled.div`
  display: flex;
  justify-content: flex-end;

  img {
    width: 6%;
    height: 6%;
    margin-top: -11%;
    cursor: pointer;

    @media(max-width: 770px) {
      width: 10%;
      height: 10%;
      margin-top: -17%;
    }
  }
`;

export const LabelModal = styled.div`
    padding-bottom: 5px;
    display: flex;
`;

export const LabelTitleModal = styled.div`
    padding-top: 15px;
    display: flex;
    font: normal normal 600 16px/20px Mangueira;
    color: #090909;
`;

export const StatusArea = styled.div`
    padding-left: 50px;
    display: flex;
    flex-direction: row;
    padding-bottom: 10px;
    padding-top: 10px;
`;

export const ObjectiveArea = styled.div`
    margin-top: 30px;
    padding-left: 50px;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    padding-bottom: 10px;
    padding-top: 10px;
`;

export const CommentArea = styled.div`
    margin-top: 10px;
    margin-bottom: 60px;
    padding-left: 50px;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    padding-bottom: 10px;
    padding-top: 10px;
`;

export const Legend = styled.div`
  font-size: 14px;
  color: #7f7f7f;
  margin-right: 6px;
`;

export const ItemDetails = styled.span`
  display: flex;
  color: #808080;
  font-size: 14px;
  font-weight: 300;
  margin-left: 27px;
  margin-right: 34px;
  justify-content: center;
  align-items: center;
  flex-direction: row;
`;

export const SelectLabel = styled.div`
    font: normal normal 600 12px Mangueira;
    color: #000000;
`;

export const Icon = styled.img`
    width: ${props => (props.hasWidth  ? props.hasWidth : '50px')};
    height: auto;
`;
